import HomepageBanner from "./HomepageBanner";
import HomepageCategory from "./HomepageCategory";
import HomepageGroup from "./HomepageGroup";
import { COMPONENTS } from "./utils/constants";
import { Content } from "./utils/homepageJson.types";

const HomepageComponentsFromJson = ({ data, homePageRow, viewedHomePageRow }: { data: Content, homePageRow: number, viewedHomePageRow: number }) => {
  switch (data.component) {
    case COMPONENTS.BANNER:
      return <HomepageBanner
        banners={data.items}
        homePageRow={homePageRow} uniqueKey={data.id}
        viewedHomePageRow={viewedHomePageRow} />;
    case COMPONENTS.GROUP:
      return <HomepageGroup
        homePageRow={homePageRow}
        items={data.items}
        title={data.title} uniqueKey={data.id} viewedHomePageRow={viewedHomePageRow} />;
    case COMPONENTS.CATEGORY:
      return <HomepageCategory
        categoryId={data.category_id}
        homePageRow={homePageRow} viewedHomePageRow={viewedHomePageRow} />;
    default:
      return null;
  }
}
export default HomepageComponentsFromJson;